// Generated types for Item
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { FlowType, ItemIdentity, TemporalPattern } from '../enums';

import { CatalogNodeReadAPI, CatalogNodeWriteAPI } from '../../shared/types/catalognode';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { CatalogNodeReadAPISchemaObject, CatalogNodeWriteAPISchemaObject } from '../../shared/types/catalognode';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ItemReadAPI extends CatalogNodeReadAPI, RFLPElementReadAPI {
  /** Pahl & Beitz partition: MATTER / ENERGY / INFORMATION. */
  flow_type: FlowType;
  /** CONTINUOUS — present over an interval, characterised by a rate (water in pipe, electric power). DISCRETE — present at moments, characterised by a quantity per firing (a widget on a conveyor, a command message). */
  temporal_pattern?: TemporalPattern;
  /** FUNGIBLE — instances interchangeable (water, generic widgets). INDIVIDUAL — each occurrence has identity and can carry history (serialised widget, specific command instance). */
  identity?: ItemIdentity;
}

export interface ItemWriteAPI extends CatalogNodeWriteAPI, RFLPElementWriteAPI {
  /** Pahl & Beitz partition: MATTER / ENERGY / INFORMATION. */
  flow_type: FlowType;
  /** CONTINUOUS — present over an interval, characterised by a rate (water in pipe, electric power). DISCRETE — present at moments, characterised by a quantity per firing (a widget on a conveyor, a command message). */
  temporal_pattern?: TemporalPattern;
  /** FUNGIBLE — instances interchangeable (water, generic widgets). INDIVIDUAL — each occurrence has identity and can carry history (serialised widget, specific command instance). */
  identity?: ItemIdentity;
  /** Default unit for ItemFlows carrying this Item (e.g. 'kg/s' for a bulk-matter item, 'W' for power). */
  canonical_unit?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ItemReadAPISchema: z.ZodType<ItemReadAPI> = CatalogNodeReadAPISchemaObject.extend(RFLPElementReadAPISchemaObject.shape).extend({
  flow_type: z.nativeEnum(FlowType),
  temporal_pattern: z.nativeEnum(TemporalPattern).optional(),
  identity: z.nativeEnum(ItemIdentity).optional(),
}).passthrough();

export const ItemWriteAPISchema: z.ZodType<ItemWriteAPI> = CatalogNodeWriteAPISchemaObject.extend(RFLPElementWriteAPISchemaObject.shape).extend({
  flow_type: z.nativeEnum(FlowType),
  temporal_pattern: z.nativeEnum(TemporalPattern).optional(),
  identity: z.nativeEnum(ItemIdentity).optional(),
  canonical_unit: z.string().optional(),
}).passthrough();
